<template>
  <v-container class="component-wrapper">
    <v-btn
      icon
      color="primary"
      @click="$router.push({ path: '/superuser' })"
      class="close-button"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <div class="text-h5 text-center title-underline mb-12" :lang="$i18n.locale">{{ $t('newPartner') }}</div>

    <div class="stepper-container">
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step :complete="step > 1" step="1">
            {{ $t('chooseDefaultLocale') }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2">{{ $t('addMuseumTitles') }}</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-select
              v-model="defaultLocale"
              :items="availableLocales"
              item-text="name"
              item-value="code"
              :label="$t('chooseLanguage')"
              outlined
              dense
              class="mt-4"
              hide-details
            ></v-select>

            <div class="d-flex justify-space-between mt-6">
              <v-btn
                small
                color="primary"
                disabled
                :lang="$i18n.locale"
              >
                <v-icon left>mdi-chevron-left</v-icon>
                {{ $t('previous') }}
              </v-btn>

              <v-btn
                small
                color="primary"
                :lang="$i18n.locale"
                :disabled="!defaultLocale"
                @click="step = 2"
              >
                {{ $t('next') }}
                <v-icon right>mdi-chevron-right</v-icon>
              </v-btn>
            </div>
            
          </v-stepper-content>

          <v-stepper-content step="2">
            <h3 class="mb-4">
              <span class="ml-2 grey--text text--darken-1">
                ({{ $t('defaultLanguage') }}: {{ defaultLocaleName }})
              </span>
            </h3>

            <museum-title-translations
              :supported-languages="translationRows"
              :default-locale="defaultLocaleName"
              :edit-mode="false"
            />

            <div class="d-flex justify-space-between mt-6">
              <v-btn
                small
                color="primary"
                :lang="$i18n.locale"
                @click="step = 1"
              >
                <v-icon left>mdi-chevron-left</v-icon>
                {{ $t('previous') }}
              </v-btn>

              <v-btn
                small
                color="primary"
                :lang="$i18n.locale"
                :disabled="!defaultLocale"
                @click="saveMuseum"
              >
                {{ $t('add') }}
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </div>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </div>

    <v-dialog v-model="dialog" max-width="400">
      <v-card>
        <v-card-title class="headline">
          {{ editingLanguageName }}
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="tempTitle"
            :label="`Translated Title (${editingLanguageName})`"
            outlined
            dense
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialog = false">Cancel</v-btn>
          <v-btn color="primary" @click="saveTranslation">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { SUPPORTED_LANGUAGES } from '@/i18n/config';
import MuseumTitleTranslations from '../../components/MuseumTitleTranslations.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    MuseumTitleTranslations
  },
  data() {
    return {
      step: 1,
      dialog: false,
      tempTitle: '',
      editingLocale: null,
      availableLocales: SUPPORTED_LANGUAGES,
      loader: false,
      titles: []
    };
  },
  computed: {
    ...mapGetters(['newMuseumObj']),
     defaultLocale: {
      get() {
        return this.$store.state.superuser.newMuseumObj.defaultLocale;
      },
      set(value) {
        this.$store.commit('setNewMuseumObjectProp', {prop: 'defaultLocale', value: value});
      }
    },
    defaultLocaleName() {
      return (
        this.availableLocales.find(l => l.code === this.defaultLocale)?.name ||
        ''
      );
    },
    translationRows() {
      return this.availableLocales
        .filter(l => l.code !== this.defaultLocale)
        .map(l => ({
          code: l.code,
          name: l.name
        }));
    },
    editingLanguageName() {
      return (
        this.availableLocales.find(l => l.code === this.editingLocale)?.name ||
        ''
      );
    }
  },
  methods: {
    ...mapActions(['addMuseum']),
    saveTranslation() {
      this.titles[this.editingLocale] = this.tempTitle.trim();
      this.dialog = false;
    },
    async saveMuseum() {
      console.log('save museum')
      this.loader = true;
      this.museumExists = false;

      try {
        const museumId = await this.addMuseum(this.newMuseumObj);

        this.$router.push({ path: `/superuser/museum/${museumId}` });
      } catch (e) {
        if (e?.response?.status == 400 && e?.response?.data?.data?.title) {
          this.museumExists = true;
        }
      }

      this.loader = false;
    },
  }
};
</script>

<style lang="css" scoped>
  .stepper-container {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .stepper-container .v-stepper {
    max-width: 800px;
  }
</style>
